/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-nested-ternary */

import "./MentionList.css";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { FaCaretRight } from "react-icons/fa";

const DATE_FORMATS = [
	{ id: "dd/mm/yyyy", label: "JJ/MM/YYYY", value: "dd/mm/yyyy" },
	{ id: "yyyy/mm/dd", label: "YYYY/MM/JJ", value: "yyyy/mm/dd" },
	{ id: "dd-mm-yyyy", label: "JJ-MM-YYYY", value: "dd-mm-yyyy" },
	{ id: "yyyy-mm-dd", label: "YYYY-MM-JJ", value: "yyyy-mm-dd" }
];

const isDateType = type => type === "date";

const MenuList = forwardRef((props, ref) => {
	const [selectedMenuItem, setSelectedMenuItem] = useState();
	const [isOpen, setIsOpen] = useState(true);

	const selectItem = item => {
		setSelectedMenuItem(item);
		if (item) {
			props.command({ id: item.title });
		}
	};

	const upHandler = () => {};
	const downHandler = () => {};
	const enterHandler = () => {
		selectItem(selectedMenuItem);
	};

	useEffect(() => {
		setSelectedMenuItem(undefined);
	}, [props.items]);

	useImperativeHandle(ref, () => ({
		onKeyDown: ({ event }) => {
			if (event.key === "ArrowUp") {
				upHandler();
				return true;
			}

			if (event.key === "ArrowDown") {
				downHandler();
				return true;
			}

			if (event.key === "Enter") {
				enterHandler();
				return true;
			}

			return false;
		}
	}));

	// Rendu récursif des sous-menus avec Radix DropdownMenu.Sub
	const renderMenuItems = (items, parentsItem = []) => {
		return items.map(item => {
			const disabled = item.disabled || false;
			const isLeaf = !item.child || item.child.length === 0;
			const isDate = isLeaf && isDateType(item.type);
			const hasSubmenu = (item.child && item.child.length > 0) || isDate;

			if (hasSubmenu) {
				return (
					<DropdownMenu.Sub key={item.id}>
						<DropdownMenu.SubTrigger
							className={`mention-menu-item ${disabled ? "mention-menu-item-disabled" : ""}`}
							disabled={disabled}
						>
							<span>{item.title}</span>
							<FaCaretRight className="mention-menu-caret" />
						</DropdownMenu.SubTrigger>
						<DropdownMenu.Portal>
							<DropdownMenu.SubContent
								className="mention-submenu-content"
								sideOffset={2}
								collisionPadding={10}
							>
								{item.child && item.child.length > 0
									? renderMenuItems(item.child, [...parentsItem, item])
									: isDate
										? DATE_FORMATS.map(format => {
												const title = parentsItem.length
													? parentsItem.map(p => p.title).join(" / ") + " / " + item.title
													: item.title;
												return (
													<DropdownMenu.Item
														key={format.id}
														className="mention-menu-item"
														onSelect={e => {
															e.preventDefault();
															props.command({
																id: title,
																label: format.value
															});
														}}
													>
														<span>{format.label}</span>
													</DropdownMenu.Item>
												);
											})
										: null}
							</DropdownMenu.SubContent>
						</DropdownMenu.Portal>
					</DropdownMenu.Sub>
				);
			}

			// Élément feuille (sans sous-menu)
			return (
				<DropdownMenu.Item
					key={item.id}
					className={`mention-menu-item ${disabled ? "mention-menu-item-disabled" : ""}`}
					disabled={disabled}
					onSelect={e => {
						e.preventDefault();
						if (!disabled) {
							const title = parentsItem.length
								? parentsItem.map(p => p.title).join(" / ") + " / " + item.title
								: item.title;
							props.command({ id: title });
						}
					}}
				>
					<span>{item.title}</span>
				</DropdownMenu.Item>
			);
		});
	};

	if (!props.items.length) return null;

	const handleOpenChange = open => {
		setIsOpen(open);
		if (!open && props.onCloseMenu) {
			props.onCloseMenu();
		}
	};

	return (
		<DropdownMenu.Root open={isOpen} onOpenChange={handleOpenChange} modal={false}>
			<DropdownMenu.Trigger asChild>
				<span className="mention-menu-anchor" />
			</DropdownMenu.Trigger>
			<DropdownMenu.Portal>
				<DropdownMenu.Content
					className="mention-menu-content"
					side="bottom"
					align="start"
					sideOffset={0}
					collisionPadding={10}
				>
					{renderMenuItems(props.items)}
				</DropdownMenu.Content>
			</DropdownMenu.Portal>
		</DropdownMenu.Root>
	);
});

export default MenuList;
